<template>
    <InputMulti
        :value="value"
        :label="label || $t('formularios.tipo_identificacion')"
        :name="validationName"
        :rules="required ? 'required' : ''"
        :options="documentTypes"
        value-key="type"
        label-key="label"
        :disabled="disabled"
        :data-cy="`tipo-documento-${index}`"
        @input="$emit('input', $event)"
    />
</template>

<script setup>
    import { computed, getCurrentInstance } from 'vue';
    import InputMulti from '@/modules/front/ui/InputMulti.vue';

    const instance = getCurrentInstance();
    const $t = instance.proxy.$t.bind(instance.proxy);

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: ''
        }
    });

    defineEmits(['input']);

    const documentTypes = [
        { type: 'DNI', label: 'DNI' },
        { type: 'NIE', label: 'NIE' },
        { type: 'NIF', label: 'NIF' },
        { type: 'PASAPORTE', label: 'PASAPORTE' },
        { type: 'OTROS', label: 'OTROS' }
    ];

    const validationName = computed(() =>
        `${$t('formularios.tipo_identificacion')}${props.index > 0 ? ` ${props.index}` : ''}`
    );
</script> -->
